var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{key:item + 1,staticClass:"shadow-sm p-3 mb-3"},[_c('skeleton-screen',{staticClass:"mb-3",attrs:{"width":"100%","height":"60px"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }